import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const user = localStorage.getItem('user');
  
  if (!user) {
    // Redirect về trang login nếu chưa có session
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute; 